var sw = sw || {};


// Menu slider - mobile
// -----------------------------------------------------------------
sw.menuSlider = function() {
    var $slider = $('.js_menuSlider').removeClass('visuallyhidden');

    if(!$slider.length) {
        return;
    }

    var swiper = new Swiper('.js_menuSlider', {
        direction = 'horizontal',
        slidesPerView = 'auto',
        // spaceBetween = 25,
        // centeredSlides = true,
        // loop: true,
        // freeMode: true,

        //Scrollbar
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,

        }
    })

    var _vpw = $(window).width();

    if(_vpw > 1200) {
        swiper.destroy();
    }
};

// Accordion figures Slider
// -----------------------------------------------------------------
sw.accordionSlider = function() {

    var $slider = $('.js_accordionSlider').removeClass('visuallyhidden');

    if(!$slider.length) {
        return;
    }

    var thumbsSwiper = new Swiper('.js_accordionThumbsSlider', {
        direction: 'horizontal',
        slidesPerView: 2,
        // loop: true,
        spaceBetween: 15,

        breakpointsInverse: true,
        breakpoints: {
            480: {
                slidesPerView: 3,
            },

            980: {
                slidesPerView: 4,
            },
        }
    });

    var swiper = new Swiper('.js_accordionSlider', {
        direction: 'horizontal',
        slidesPerView: 1,

        thumbs: {
            swiper: thumbsSwiper
        }
    });

};

// Jury Slider
// -----------------------------------------------------------------
sw.jurySlider = function() {
    var $slider = $('.js_jurySlider').removeClass('visuallyhidden');

    if(!$slider.length) {
        return;
    }

    var swiper = new Swiper('.js_jurySlider', {
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        
        //naviogation
        navigation: {
            nextEl: '.js_jurySliderButtonNext',
            prevEl: '.js_jurySliderButtonPrev',
        },

        breakpointsInverse: true,
        breakpoints: {

            920: {
                slidesPerView: 3,
            },
        }
    });
};

$(document).ready(function() {
    sw.menuSlider();
    sw.accordionSlider();
    sw.jurySlider();
});
